module.exports = {
	methods: {
		searchWordLink: function(str){
			this.updateSearchWordsLink(str);
			this.setSCStr(str);
			this.$route.router.go({
				name: 'searchresult',
				query: {
					w: str,
					c: ''
				}
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/mixins/searchWordLink.js